
<template>
    
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		</div>
		<div class="mb-2 mt-2 pt-3">
			<button-search :isphone="layout.is_phone" ref="buttonSearch" placeholder="搜索 姓名｜班別" @search="searchEvent" :showGj="true">
				<!-- 高級搜索 1-->
				<template #from>
					<el-form inline ref="form" :model="from" label-width="100px">
						<el-form-item label="姓名" class="mb-0">
							<el-input size="small" v-model="from.name" placeholder="搜索姓名"></el-input>
						</el-form-item>

						<el-form-item label="班別" class="mb-0">
							<el-input size="small" v-model="from.class_id" placeholder="搜索班別"></el-input>
						</el-form-item>
						
						<el-form-item label="學號" class="mb-0">
							<el-input size="small" v-model="from.number" placeholder="搜索學號"></el-input>
						</el-form-item>

						<el-form-item label="學校" class="mb-0">
							<el-select v-model="from.school_id" size="small" placeholder="請選擇學校" clearable filterable style="width: 200px;">
								<el-option label="全部" :value="-1"></el-option>
								<el-option v-for="item in school_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
							</el-select>
						</el-form-item>

                        <el-form-item label="狀態" class="mb-0">
							<el-select v-model="from.status" size="small" placeholder="請選擇查看類型">
								<el-option label="全部" :value="-1"></el-option>
								<el-option label="已處理" :value="1"></el-option>
								<el-option label="未處理" :value="0"></el-option>
							</el-select>
						</el-form-item>

						<el-form-item label="創建時間" size="small" class="mb-0">
							<el-date-picker v-model="from.time" type="daterange" align="right" unlink-panels value-format="yyyy-MM-dd"
							 range-separator="至" start-placeholder="開始日期" end-placeholder="結束日期" :picker-options="pickerOptions">
							</el-date-picker>
						</el-form-item>

						<el-form-item class="mb-0">
							<el-button type="info" @click="searchEvent" size="small">搜索 </el-button>
							<el-button size="small" @click="clearSearch">清空篩選條件</el-button>
						</el-form-item>
					</el-form>
				</template>
			</button-search>
		</div>
        

		<!-- 表格 -->
		<div class="mt-3 pt-2">
			<el-table :data="tableData" @sort-change="sortChange" border style="width: 100%" @selection-change="handleSelectionChange">
				<el-table-column align="center" prop="name" label="姓名">
				</el-table-column>
				
				<el-table-column align="center" prop="school_name" label="學校">
				</el-table-column>
				
				<el-table-column align="center" prop="class_id" label="班別">
				</el-table-column>

				<el-table-column align="center" prop="number" label="學號">
				</el-table-column>

				<el-table-column align="center"  prop="status"  label="狀態">
					<template slot-scope="v">
						<span style="color: red;" v-if="v.row.status==0">未處理</span>
						<span class="text-success" v-if="v.row.status==1">已處理</span>
					</template>
				</el-table-column>

				<el-table-column align="center" prop="create_time" width="200" label="創建時間">
				</el-table-column>
				
                <el-table-column prop="id" :fixed="this.layout.is_phone?false:'right'" align="center" width="140" label="操作">
					<template slot-scope="scope">
						<el-button-group>
							<el-button :disabled="scope.row.status !== 0" @click="openModel(scope.row)"  v-auth="'edit'+auth_val" size="mini" plain type="danger" :class="{'is-disabled': scope.row.status !== 0}" > {{ scope.row.status !== 0 ? '已處理' : '處理' }}</el-button>
						</el-button-group>
					</template>
				</el-table-column>

			</el-table>
		</div>


		<div style="height: 60px;"></div>
		<el-footer class="d-flex border-top bg-white align-items-center px-0 position-fixed all_foot_page" >
			<!-- 底部 -->

			<div style="flex: 1;" class="px-2">
				<el-pagination :current-page="page.current" :page-sizes="page.sizes" :page-size="page.size" @size-change="handleSizeChange"
				 @current-change="handleCurrentChange" layout="total, sizes, prev, pager, next, jumper" :total="page.total">
				</el-pagination>
			</div>
		</el-footer>

		

		<el-dialog  :close-on-click-modal="false" title="修改密碼" :visible.sync="createModel" top="5vh" :width="layout.is_phone?'90%':'50%'">
			<!-- 表單内容 -->
			<el-form :rules="rules" ref="form" :model="form" :label-width="layout.is_phone?'80px':'100px'">

				<el-form-item label="登錄密碼" prop="password">
					<el-input v-model="form.password" :maxlength="16" :minlength="6" show-password placeholder="登錄密碼" size="small" auto-complete="new-password"
					 style="width: 85%;"></el-input>
				</el-form-item>

				<el-form-item label="確認密碼" prop="password2">
					<el-input v-model="form.password2" :maxlength="16" :minlength="6" show-password placeholder="確認密碼" size="small"
					 style="width: 85%;"></el-input>
				</el-form-item>
			</el-form>


			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">取 消</el-button>
				<el-button type="primary" @click="submit">確 定</el-button>
			</div>
		</el-dialog>

	</div>
</template>

<style>
  .demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
</style>
<script>
	import { commondecrypt } from '@/main';
	import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue';
	import { mapState } from 'vuex';
	export default {
		components: {
			buttonSearch
		},
		inject: ['layout', 'app'],
		mixins: [common],
		data() {
			return {
				createModel: false,
				editIndex: -1,
				//搜索數据
				from: {
					name: '',
					class_id: '',
					number: '',
					school_id: -1,
					status: -1,
					time: [],
				},
				model_title: 'Notice',
				auth_val: 'data/resetpass',
				preUrl: "user/ForgetList", //列表地址
                addUrl: "user/editStatusForget", //修改狀態地址

				tableData: [],
				form: {
					id: 0,
					password:'',
					password2:"",
				},
				prop: 'create_time',
				sort: 'descending',
				rule_list: [],
				total_list: [],
				check_img_list: [],
				fileList: [],

				school_list: [],
				inst_list: [],
				user_list: [],
				rules: {
					
					password:[
						{
							min: 6,
							max: 16,
							message: '密碼必須6至16個數字或英文字',
							trigger: 'blur'
						}
					],
				

				},

			}
		},
		watch: {
			refreshTrigger(newVal) {
				console.log('刷新触发，當前值:', newVal);
				this.getList();    // 如果有其他需要刷新的方法
				this.layout.getPageNum();
			},
		},
		computed: {
			...mapState(['refreshTrigger']), // 监听 Vuex state
		},
		created() {
			// common mixin 的 created 会自动调用 getList()，但我们需要先获取学校列表
			// 所以先获取学校列表，然后在回调中调用 getList
			this.getSchoolList();
		},
		methods: {
			
			handleClick(tab, event) {
				this.search = ''
				this.clearSearch()
				this.getList()
			},
			sortChange(column) {

				this.prop = column.prop
				this.sort = column.order
				this.getList()
			},
			
			//提交
			submit() {
				if (this.form.password != this.form.password2) {
					this.$message({
						message: '兩次密碼輸入不一致',
						type: 'error'
					});
					return
				}
				this.$refs.form.validate(res => {
					if (res) {
						this.form.id = this.editIndex
						this.axios.post('/admin/user/editStatusForget', this.form, {
							token: true,
						}).then(res => {
							let all = res.data
							if (all.code == 1) {
									this.$message({
										message: '修改完成',
										type: 'success'
									}); // 控制是否顯示成功提示
								
								this.createModel = false
								this.getList()
								this.layout.getPageNum();
							}else{
								this.$message.error('操作失敗');
							}
						
							// this.layout.loading = false;
						}).catch(err => {
							// 失敗
							this.$message.error('操作失敗');
							
							// this.layout.loading = false;
						})
					}
				})
			},
			
		
			handleAvatarSuccess(res, file) {
				this.form.img = URL.createObjectURL(file.raw);
				let en_data = commondecrypt(res.encryption)
				res.encryption = JSON.parse(en_data)
				if(res.encryption.code==1){
					this.form.head = res.encryption.data.list.url
				}
			  },
			
			  beforeAvatarUpload(file) {
				const isJPG = file.type === 'image/jpeg';
				const isLt2M = file.size / 1024 / 1024 < 2;
				return isJPG && isLt2M;
			  },
			

			// 打开模态框
			openModel(e, type) {
				// 修改
				
					this.form = {
						id:  e.id,
						password: '',
						password2: '',
					}
					this.editIndex = e.id
				
				
				// 打开dialog
				this.createModel = true
			},

			//公共列表
			getSchoolList() {
				this.layout.loading = true;
				this.axios.post('/admin/user/commonList', {
					type: ['school_list'],
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
					this.school_list = list.school || []

					this.layout.loading = false;
					// 确保在获取学校列表后加载数据列表
					if (this.preUrl && this.preUrl !== 'data/UserList') {
						this.getList();
					}
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
					// 即使失败也尝试加载数据列表
					if (this.preUrl && this.preUrl !== 'data/UserList') {
						this.getList();
					}
				})
			},

			//前往修改页面
			editItem(obj) {
				this.$router.push({
					name: 'set_manager_rule',
					query: {
						item: obj
					}
				})
			},
			getListResult(e) {
				this.tableData = e.list
				this.total_list = e.total_list
				this.check_img_list = e.list.map(item => {
					return item.head
				})
			},
			// 清空篩選條件
			clearSearch() {
				this.from = {
					name: '',
					class_id: '',
					number: '',
					school_id: -1,
					status: -1,
					time: [],
				}

				this.$refs.buttonSearch.closeSuperSearch()
				this.search = ''
				this.getList()
			},
			// 選擇图片
			chooseImage() {
				this.app.chooseImage((res) => {
					//console.log(res)
					//this.form.headUrl = ''
					this.$set(this.form, 'headUrl', res[0].url);
					this.form['headId'] = res[0].id
					this.$set(this.form, 'headId', res[0].id);
					//this.form.headUrl = res[0].url
				}, 1)
			}
		}
	}
</script>

<style>
</style>
